import { render, staticRenderFns } from "./version.vue?vue&type=template&id=0298a6aa&scoped=true&"
import script from "./version.vue?vue&type=script&lang=js&"
export * from "./version.vue?vue&type=script&lang=js&"
import style0 from "./version.vue?vue&type=style&index=0&id=0298a6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0298a6aa",
  null
  
)

export default component.exports